import { FC } from 'react'

import { CampaignStatusEnum } from 'src/Types/campaigns'
import { StatsBlock } from 'src/Components/StatsSectionBlock'
import { HORIZONTAL_AMOUNT } from 'src/Constants/constants'

interface BudgetSectionProps {
  campaignStatus: CampaignStatusEnum
  budget?: number | null
  spent?: number
  reserved?: number
  hasNotCompletedEvents?: boolean
  credits?: number
}

export const BudgetSection: FC<BudgetSectionProps> = ({
  campaignStatus,
  budget,
  spent,
  reserved,
  hasNotCompletedEvents,
  credits,
}) => {
  const budgetSectionVisible = ![
    CampaignStatusEnum.AWAITING_REVIEW,
    CampaignStatusEnum.PENDING,
  ].includes(campaignStatus)

  if (!budgetSectionVisible) {
    return null
  }

  const campaignCanDisplayCredits = [
    CampaignStatusEnum.ENDED,
    CampaignStatusEnum.STOPPED,
    CampaignStatusEnum.CANCELED,
    CampaignStatusEnum.CANCELED_BY_ADMIN,
    CampaignStatusEnum.STOPPED_BY_ADMIN,
  ].includes(campaignStatus)
  const hasPendingEvents = hasNotCompletedEvents ?? reserved !== 0
  const isCreditsDisplayed =
    campaignCanDisplayCredits && !hasPendingEvents && Boolean(credits)
  const isReservedDisplayed = !campaignCanDisplayCredits || hasPendingEvents

  const sections = [
    {
      title: 'Budget',
      value: `$${budget?.toFixed(2)}`,
    },
    {
      title: 'Reserved',
      value: `$${reserved?.toFixed(2)}`,
      isVisible: isReservedDisplayed,
    },
    {
      title: 'Spent',
      value: `$${spent?.toFixed(2)}`,
    },
    {
      title: 'Credits',
      value: `$${credits?.toFixed(2)}`,
      isVisible: isCreditsDisplayed,
    },
  ].filter((section) => section.isVisible !== false)

  return (
    <StatsBlock
      sections={sections}
      $isHorizontal={sections.length <= HORIZONTAL_AMOUNT}
    />
  )
}
